import { colors } from '@/constants/theme';

export const componentColors = {
  default: colors.black200,
  blue: '#0e71ff',
};

export const borderColors = {
  default: 'rgba(21, 27, 38, 0.3)',
  blue: 'rgba(1, 96, 235, 0.3)',
};
